import { apiClient } from "../../../base/ApiClient";


export const getMealsByClientID = async (clientId) => {
  const response = await apiClient.get(`/observations/meals/?client=${clientId}`);
  return response.data;
};

export const getMealByID = async (id) => {
  const response = await apiClient.get(`/observations/meals/${id}/`);
  return response.data;
};

export const createMeal = async (mealData) => {
  const response = await apiClient.post(`/observations/meals/`, mealData);
  return response.data;
};

export const updateMeal = async (id, mealData) => {
  const response = await apiClient.patch(`/observations/meals/${id}/`, mealData);
  return response.data;
};

export const deleteMeal = async (id) => {
  const response = await apiClient.delete(`/observations/meals/${id}/`);
  return response.data;
};